import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

import colors from './colors'
import { accordionSlotRecipe } from './components/Accordion'
import { avatarSlotRecipe } from './components/Avatar'
import { badgeRecipe } from './components/Badge'
import { buttonRecipe } from './components/Button'
import { checkboxSlotRecipe } from './components/Checkbox'
import { containerRecipe } from './components/Container'
import { drawerSlotRecipe } from './components/Drawer'
import { inputRecipe } from './components/Input'
import { linkRecipe } from './components/Link'
import { listSlotRecipe } from './components/List'
import { menuSlotRecipe } from './components/Menu'
import { popoverSlotRecipe } from './components/Popover'
import { progressRecipe } from './components/Progress'
import { radioSlotRecipe } from './components/Radio'
import { separatorRecipe } from './components/Separator'
import { skeletonRecipe } from './components/Skeleton'
import { sliderSlotRecipe } from './components/Slider'
import { switchSlotRecipe } from './components/Switch'
import { tableSlotRecipe } from './components/Table'
import { tabsSlotRecipe } from './components/Tabs'
import { tagSlotRecipe } from './components/Tag'
import { textareaRecipe } from './components/Textarea'
import { tooltipSlotRecipe } from './components/Tooltip'
import { styles } from './styles'
import { toastSlotRecipe } from './Toast'

// export const config = {
//     initialColorMode: 'system',
//     useSystemColorMode: true,
// }

const customConfig = defineConfig({
    globalCss: styles,
    theme: {
        // config,
        slotRecipes: {
            avatar: avatarSlotRecipe,
            accordion: accordionSlotRecipe,
            checkbox: checkboxSlotRecipe,
            drawer: drawerSlotRecipe,
            list: listSlotRecipe,
            menu: menuSlotRecipe,
            popover: popoverSlotRecipe,
            radioGroup: radioSlotRecipe,
            slider: sliderSlotRecipe,
            switch: switchSlotRecipe,
            table: tableSlotRecipe,
            tabs: tabsSlotRecipe,
            tag: tagSlotRecipe,
            toast: toastSlotRecipe,
            tooltip: tooltipSlotRecipe,
        },
        recipes: {
            badge: badgeRecipe,
            button: buttonRecipe,
            container: containerRecipe,
            input: inputRecipe,
            link: linkRecipe,
            separator: separatorRecipe,
            progress: progressRecipe,
            skeleton: skeletonRecipe,
            textarea: textareaRecipe,
        },
        tokens: {
            colors,
        },
    },
})

export const system = createSystem(defaultConfig, customConfig)
